module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/room-rectangle-solid-064d5e7027bf09bbe35eaac2c9ad79db.svg";